import React, { useState, useEffect } from 'react';
import { FiMail, FiPhone, FiMapPin, FiClock, FiShield, FiFacebook, FiInstagram, FiYoutube } from 'react-icons/fi';
import { FaTiktok } from 'react-icons/fa';
import { publicAPI } from '../../services/api';
import './Contacto.css';

const Contacto = () => {
  const [config, setConfig] = useState({
    email: 'cmarketing@imdi.com.ve',
    phone: '+584246008385',
    address: 'Calle 18 entre Avenidas 6 y 7A Sierra maestra\nSan francisco Edo. Zulia',
    schedule: 'Lunes a Viernes: 7:30 am a 4:30 pm',
    map_embed_url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3926.368847766576!2d-67.99848268520386!3d10.23163199269279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e80677709012345%3A0x123456789abcdef!2sValencia%2C%20Carabobo!5e0!3m2!1ses!2sve!4v1625000000000!5m2!1ses!2sve',
    facebook_url: 'https://facebook.com',
    instagram_url: 'https://instagram.com',
    youtube_url: 'https://youtube.com',
    tiktok_url: ''
  });
  const [heroStyle, setHeroStyle] = useState({ background: 'rgb(116, 70, 49)', color: 'white' });
  const [pageLoading, setPageLoading] = useState(true);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState({
    loading: false,
    error: null,
    success: false
  });
  const [captcha, setCaptcha] = useState({
    num1: Math.floor(Math.random() * 10) + 1,
    num2: Math.floor(Math.random() * 10) + 1,
    response: ''
  });

  useEffect(() => {
    const loadPageData = async () => {
      try {
        const [configRes, heroImageRes] = await Promise.all([
          publicAPI.getConfiguration(),
          publicAPI.getHeroImage()
        ]);

        if (configRes.data && Object.keys(configRes.data).length > 0) {
          setConfig(prev => ({ ...prev, ...configRes.data }));
        }

        if (heroImageRes.data) {
          const { file_path, type } = heroImageRes.data;
          if (type === 'image') {
            setHeroStyle({ background: `url(${file_path}) center/cover no-repeat`, color: 'rgb(116, 70, 49)' });
          } else if (type === 'color') {
            setHeroStyle({ background: file_path, color: 'white' });
          }
        }
      } catch (err) { console.error('Error loading page data:', err); }
      finally { setPageLoading(false); }
    };
    loadPageData();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar Captcha
    if (parseInt(captcha.response) !== captcha.num1 + captcha.num2) {
      setStatus({
        loading: false,
        error: 'La respuesta de seguridad es incorrecta.',
        success: false
      });
      return;
    }

    setStatus({ loading: true, error: null, success: false });

    try {
      await publicAPI.sendContactMessage(formData);
      setStatus({
        loading: false,
        error: null,
        success: true
      });
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setCaptcha({
        num1: Math.floor(Math.random() * 10) + 1,
        num2: Math.floor(Math.random() * 10) + 1,
        response: ''
      });
    } catch (error) {
      setStatus({
        loading: false,
        error: error.response?.data?.message || 'Hubo un error al enviar el mensaje.',
        success: false
      });
    }
  };

  if (pageLoading) return <div className="loading">Cargando...</div>;

  return (
    <div className="contacto" style={{ color: 'rgb(116, 70, 49)' }}>
      <div className="container">
        <section className="hero-section" style={heroStyle}>
          <h1>Contacto</h1>
          <p className="subtitle">Estamos aquí para ayudarte</p>
        </section>

        <div className="contact-content">
          <div className="contact-info">
            <h2>Información de Contacto</h2>
            <div className="info-item">
              <FiMail className="icon" />
              <div>
                <h3>Email</h3>
                <p>{config.email}</p>
              </div>
            </div>
            <div className="info-item">
              <FiPhone className="icon" />
              <div>
                <h3>Teléfono</h3>
                <p>{config.phone}</p>
              </div>
            </div>
            <div className="info-item">
              <FiMapPin className="icon" />
              <div>
                <h3>Ubicación</h3>
                <p style={{ whiteSpace: 'pre-line' }}>{config.address}</p>
              </div>
            </div>
            <div className="info-item">
              <FiClock className="icon" />
              <div>
                <h3>Horario</h3>
                <p>{config.schedule}</p>
              </div>
            </div>

            {/* Sección Adicional para rellenar espacio */}
            <div className="additional-info-section">
              <h3>Síguenos en Redes Sociales</h3>
              <p>Mantente conectado con nosotros para conocer nuevos productos y promociones exclusivas.</p>
              
              <div className="social-icons-container">
                {config.facebook_url && (
                  <a href={config.facebook_url} target="_blank" rel="noopener noreferrer" className="social-icon-link" title="Facebook">
                    <FiFacebook />
                  </a>
                )}
                {config.instagram_url && (
                  <a href={config.instagram_url} target="_blank" rel="noopener noreferrer" className="social-icon-link" title="Instagram">
                    <FiInstagram />
                  </a>
                )}
                {config.youtube_url && (
                  <a href={config.youtube_url} target="_blank" rel="noopener noreferrer" className="social-icon-link" title="YouTube">
                    <FiYoutube />
                  </a>
                )}
                {config.tiktok_url && (
                  <a href={config.tiktok_url} target="_blank" rel="noopener noreferrer" className="social-icon-link" title="TikTok">
                    <FaTiktok />
                  </a>
                )}
              </div>

              <div className="info-block">
                <h4>Envíos a Nivel Nacional</h4>
                <p>Realizamos despachos seguros a todo el país. Contáctanos para coordinar tu envío con la agencia de tu preferencia.</p>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <h2>Envíanos un Mensaje</h2>
            
            {status.success && (
              <div className="alert success">
                ¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.
              </div>
            )}

            {status.error && (
              <div className="alert error">
                {status.error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="name">Nombre</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Teléfono</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Asunto</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Mensaje</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              ></textarea>
            </div>

            <div className="form-group captcha-group">
              <label htmlFor="captcha">
                <FiShield style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                Pregunta de Seguridad: ¿Cuánto es {captcha.num1} + {captcha.num2}?
              </label>
              <input
                type="number"
                id="captcha"
                value={captcha.response}
                onChange={(e) => setCaptcha({ ...captcha, response: e.target.value })}
                placeholder="Escribe el resultado"
                required
              />
            </div>

            <button type="submit" className="submit-btn" disabled={status.loading}>
              {status.loading ? 'Enviando...' : 'Enviar Mensaje'}
            </button>
          </form>
        </div>

        <div className="map-section">
          <iframe 
            src={config.map_embed_url}
            width="100%" 
            height="450" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy"
            title="Ubicación IMDI"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contacto;
